"use client";
import { memo } from "react";

import CalculationStep from "./calculation-step/calculation-step";
import { useSignUpContext } from "../context/sign-up.context";
import AccountStep from "./sign-up-step/steps/account/account";
import AddressStep from "./sign-up-step/steps/address/address";
import PaymentStep from "./sign-up-step/steps/payment/payment";
import PixInfo from "./sign-up-step/steps/pix-info/pix-info";
import AfterPayment from "./sign-up-step/steps/after-payment/after-payment";
import BankSlipInfo from "./sign-up-step/steps/bank-slip-info/bank-slip-info";

const SignUpContent = () => {
  const { signUpReducer } = useSignUpContext();

  const handleRenderSignUpStep = () => {
    switch (signUpReducer.signUpStep) {
      case 0:
        return <AccountStep />;
      case 1:
        return <AddressStep />;
      case 2:
        return <PaymentStep />;
      case 3:
        return <PixInfo />;
      case 4:
        return <BankSlipInfo />;
      case 5:
        return <AfterPayment />;
    }
  };

  return (
    <div className="flex w-full px-size-x8 gap-size-x8 flex-wrap max-w-[1560px] tabletSmall:px-size-x10 tabletLarge:px-size-x20">
      {signUpReducer.step === "calculation" && <CalculationStep />}
      {signUpReducer.step === "sign-up" && handleRenderSignUpStep()}
    </div>
  );
};

export default memo(SignUpContent);
